export default __webpack_public_path__ + "static/media/track.70fdaaa6.svg";